<template>
  <div class="formily-test">
    <SchemaForm
      :schema="schema"
      :components="components"
      :on-submit="handleSubmit"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { FormItem, Input, Submit } from '@formily/element-plus';

const components = {
  FormItem,
  Input,
  Submit,
};

const schema = ref({
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: 'Name',
      'x-decorator': 'FormItem',
      'x-component': 'Input',
    },
    age: {
      type: 'number',
      title: 'Age',
      'x-decorator': 'FormItem',
      'x-component': 'Input',
    },
    submit: {
      type: 'void',
      'x-component': 'Submit',
      'x-component-props': {
        onClick: 'submit',
      },
    },
  },
});

const handleSubmit = (values: any) => {
  console.log('Form values:', values);
  alert(`Submitted: ${JSON.stringify(values)}`);
};
</script>

<style scoped>
.formily-test {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}
</style> 